export enum QueryType {
	SELECT,
	INSERT,
	UPDATE,
	DELETE,
}
